import React from 'react';
import {
  LayoutDashboard,
  Link2,
  Users,
  Wallet,
  BarChart3,
  HelpCircle,
  Settings,
} from 'lucide-react';

export interface NavItem {
  name: string;
  href: string;
  icon: React.ElementType;
  permission?: string;
  tierRequired?: string;
}

export const NAVIGATION_ITEMS: readonly NavItem[] = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Referral Links', href: '/referrals', icon: Link2, permission: 'org:referrals:read' },
  { name: 'Leads & Customers', href: '/leads', icon: Users, permission: 'org:customers:read' },
  { name: 'Payouts & Ledger', href: '/payouts', icon: Wallet, permission: 'org:payouts:read' },
  { name: 'Analytics', href: '/analytics', icon: BarChart3, permission: 'org:analytics:read' },
  { name: 'Support & Chat', href: '/support', icon: HelpCircle, permission: 'org:support:chat' },
  { name: 'Settings', href: '/settings', icon: Settings },
] as const;
